import React, { useEffect, useState } from "react";
import TableComponent from "../../../layoutComponents/TableComponent";
import CreatePayment from "./CreatePayment";
import { EndPoints } from "../../../utils/EndPoints";
import { apiCall } from "../../../redux/modules/moduleActions";
import { Box, Tooltip, Typography } from "@mui/material";
import { MoreHorizOutlined } from "@material-ui/icons";
import { disableColor, primary, white } from "../../../styles/colors";
const paymentDataHeaders = [
  "Sr.No.",
  "Date",
  "Payment ID",
  "Payment Amount",
  "Allocated to Bills",
  "Allocated to Advance",
  "Remark",
  //   "Actions",
];
const getFormattedDate = (dateString) => {
  const date = new Date(dateString);
  const options = { month: "short", day: "numeric", year: "numeric" };
  const formattedDate = date.toLocaleDateString("en-US", options);
  const day = date.getDate();

  const daySuffix =
    day === 1 || day === 21 || day === 31
      ? "st"
      : day === 2 || day === 22
      ? "nd"
      : day === 3 || day === 23
      ? "rd"
      : "th";

  return formattedDate.replace(day, `${day}${daySuffix}`);
};


function BrokerPayments({ singlelistView, BrokersFunction, userRole, fetchAgain }) {
  const [payments, setPayments] = useState({ list: [], advance: 0, count: 0 });
  const [editRowData, setEditRowData] = useState(null);
  const [adminBrokerage, setAdminBrokerage] = useState(true);
  const fetchPayments = async (brokerDetail, nextURL='') => {
    const getNextBill = EndPoints.brokerPayments.getList();
    const res = await apiCall({
      method: "get",
      api: nextURL ? nextURL : userRole == 'miller' ?  `${getNextBill}?broker_id=${brokerDetail.id}&brokerage_of=MILLER`: adminBrokerage  ? `${getNextBill}?broker_id=${brokerDetail.id}&brokerage_of=ADMIN` : `${getNextBill}?broker_id=${brokerDetail.id}&brokerage_of=MILLER`,
    });
    setPayments({ list: res.results, ...res });
  };

  useEffect(() => {
    if (singlelistView && singlelistView !== null) {
      fetchPayments(singlelistView);
    }
  }, [singlelistView, adminBrokerage]);
  return (
    <Box>
     
      <TableComponent
        header={paymentDataHeaders}
        descending={true}
        setSelectedList={(selected) => {
          setEditRowData(selected); 
        }}
        noAddButton={['broker' , 'miller'].includes(userRole)}
        actions={['broker' , 'miller'].includes(userRole) ? [] : Boolean(editRowData?.is_bill_advanced) && [{name: ''}]}
        noAction={{
                  ui: (rowData) =>
                    Boolean(rowData?.is_bill_advanced) ? (
                      <Tooltip title="Bill Allocated" placement="top">
                        <div
                          className="d-flex alignC justifyC"
                          style={{
                            margin: "12px 10px",
                            width: "50px",
                          }}
                        >
                          <MoreHorizOutlined style={{ color: disableColor }} />
                        </div>
                      </Tooltip>
                    ) : (
                      false
                    ),
                }}
        tableList={
          payments.list && payments.list.length > 0
            ? payments.list.map((item, index) => {
                const date = item.payment_date;
                return {
                  ...item,
                  Date: getFormattedDate(date),
                  "Payment ID": item.payment_id,
                  "Payment Amount": `₹ ${Number(
                    item.payment_amount ?? 0
                  ).toFixed(0)}/-`,
                  "Allocated to Bills": `₹ ${item.paid_bills
                    .reduce((sum, bill) => {
                      return sum + parseFloat(bill.allocated_to_bill || 0);
                    }, 0)
                    .toFixed(0)}/-`,
                  "Allocated to Advance": `₹ ${Number(
                    item.allocated_to_advanced ?? 0
                  ).toFixed(0)}/-`,
                  Remark: item.remark,
                };
              })
            : []
        }
        filterChild={() => (
          userRole !== 'miller' &&
          <div
                    className="d-flex "
                    style={{
                      border: "1px solid rgba(0, 0, 0, 0.23)",
                      width: "fit-content",
                      borderRadius: "4px",
                      marginRight: "10px",
                      height: 35,
                    }}
                  >
                    <div
                      className="d-flex alignC textOEllipse"
                      onClick={() => {
                        if (!adminBrokerage) {
                          setAdminBrokerage(true);
                        }
                      }}
                      style={{
                        borderRight: "1px solid rgba(0, 0, 0, 0.23)",
                        padding: "5px 12px",
                        cursor: !adminBrokerage ? "pointer" : "inherit",
                        background: adminBrokerage ? '#855317' : "inherit",
                        color: adminBrokerage ? white : "inherit",
                        fontSize: 13
                      }}
                    >
                      Admin Brokerage
                    </div>{" "}
                    <div
                      className="d-flex alignC textOEllipse"
                      style={{
                        padding: "5px 12px",
                        cursor: adminBrokerage ? "pointer" : "inherit",
                        background: !adminBrokerage ? '#855317' : "inherit",
                        color: !adminBrokerage ? white : "inherit",
                        fontSize: 13
                      }}
                      onClick={() => {
                        if (adminBrokerage) {
                          setAdminBrokerage(false);
                        }
                      }}
                    >
                      Miller Brokerage
                    </div>
                  </div>
        )}
        module="Payment"
        customCreateFile={(rest) => {
          return (
            <CreatePayment
              {...rest}
              brokerDetail={singlelistView}
              apiCall={BrokersFunction}
              userRole={userRole}
              adminBrokerage={adminBrokerage}
              fetchAgain={fetchAgain}
              onClose={() => {
                setEditRowData(null);
                rest.onClose();
                if (singlelistView && singlelistView !== null) {
                  fetchPayments(singlelistView);
                }
              }}
            />
          );
        }}
        pagination={{
          count: payments.count,
          next: payments.next,
          previous: payments.previous,
          customPagination: true,
          tablePagination: (url) => {
            fetchPayments(singlelistView, url);
          },
          
        }}
      />
    </Box>
  );
}

export default BrokerPayments;
